module.exports = __webpack_public_path__ + "img/Icon-tree-company-settings.5344b774.svg";